/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseListIconAsset } from '../models/api-response-list-icon-asset';
import { getActiveIcons } from '../fn/icon-asset-client-api/get-active-icons';
import { GetActiveIcons$Params } from '../fn/icon-asset-client-api/get-active-icons';

@Injectable({ providedIn: 'root' })
export class IconAssetClientApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getActiveIcons()` */
  static readonly GetActiveIconsPath = '/v1/api/icon-asset-client/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getActiveIcons()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActiveIcons$Response(params?: GetActiveIcons$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListIconAsset>> {
    return getActiveIcons(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getActiveIcons$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActiveIcons(params?: GetActiveIcons$Params, context?: HttpContext): Observable<ApiResponseListIconAsset> {
    return this.getActiveIcons$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListIconAsset>): ApiResponseListIconAsset => r.body)
    );
  }

}
